// generated by admin_tool_generator gem
import ActsAsTaggableOnTagList from 'apps/admin/pages/tags/list';
import ActsAsTaggableOnTagForm from 'apps/admin/pages/tags/form';
import OnboardingStepList from 'apps/admin/pages/onboarding-steps/list';
import OnboardingStepForm from 'apps/admin/pages/onboarding-steps/form';

export const RouterComponents = {
  '/admin/tags/:id': ActsAsTaggableOnTagForm,
  '/admin/tags': ActsAsTaggableOnTagList,
  '/admin/onboarding-steps/:id': OnboardingStepForm,
  '/admin/onboarding-steps': OnboardingStepList,
};

export const NavLinks = {
  ActsAsTaggableOnTagList: '/admin/tags',
  OnboardingStepList: '/admin/onboarding-steps',
};
